<template>
  <div>
      <v-card class="mx-auto content-personal" max-width="95%" style="padding:30px; font-size: 14px;" :flat='true'>

        <v-card-title style="color:gray; font-weight:bold; padding-left: 0px;">
          <div style="margin-left: 20px;">
            <v-tabs v-model="activeTab" centered>
              <v-tab :key="1">24 окт.</v-tab>
              <v-tab :key="2">25 окт.</v-tab>
              <v-tab :key="3">26 окт.</v-tab>
              <v-tab :key="4">27 окт.</v-tab>
            </v-tabs>
          </div>
        </v-card-title>

        <v-tabs-items v-model="activeTab">
          <v-tab-item :key="1">
            <!-- <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">9:00 - 10:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Регистрация участников экскурсии</b>
              </v-col>
            </v-row> -->
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">10:00 - 12:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Экскурсия в НИЦ "Курчатовский институт"</b>
                <br>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">территория Центра</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">12:30 - 14:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Регистрация участников и гостей Форума</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">холл первого этажа Дома ученых</b>
                </div>
                <b class="prog-text">Приветственный кофе-брейк</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">холл второго этажа Дома ученых</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">14:00 - 14:10</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 18px;">Открытие Форума</b>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">актовый зал Дома ученых</b>
                </div>
                <!-- <br>
                <b class="prog-text" style="font-size: 16px;">Лекция </b>
                <b class="prog-text" style="font-size: 16px;">«НИЦ «Курчатовский институт»: на острие научного прогресса»</b>
                <br>
                <p class="prog-text ml-6">Ковальчук М.В., Президент НИЦ «Курчатовский институт»</p> -->
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">14:10 - 16:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Пленарная дискуссия </b>
                <b class="prog-text" style="font-size: 16px;">«Установки мегакласса: долгосрочная перспектива или современная реальность»</b>
                <br>
                <p class="prog-text ml-6">Модератор: Ковальчук М.В., Президент НИЦ «Курчатовский институт»</p>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">актовый зал Дома ученых</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">16:30 - 17:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Кофе-брейк</b>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">17:00 - 18:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Постерная сессия</b>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :key="2">
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">10:00 - 11:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Пленарные выступления </b>
                <br>
                <p class="prog-text ml-6">Модератор: Борисов К.Е., главный ученый секретарь НИЦ «Курчатовский институт»</p>
                <v-btn 
                  small 
                  class='pa-2'
                  style="width:200px; " 
                  color="red" 
                  outlined
                  @click="details_modal = true; details_type = 1">подробнее
                </v-btn>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">актовый зал Дома ученых</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">11:30 - 12:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Кофе-брейк</b>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">12:00 - 14:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Сессия 1: </b>
                <b class="prog-text" style="font-size: 16px;">«Актуальные исследования и разработки, выполняемые на источниках синхротронного излучения и нейтронов, а также комплексах ядерной медицины»</b>
                <!-- <br>
                <p class="prog-text ml-6">(в том числе проекты по итогам выполнения постановления Правительства РФ №951)</p> -->
                <br>
                <v-row>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 14px;">Секция 1.1: </b>
                    <b class="prog-text" style="font-size: 16px;">Синхротронные и нейтронные исследования (разработки) в области материаловедения для развития наукоемких производственных технологий [конструкционные материалы]</b>
                    <br>
                    <p class="prog-text ml-6">Председатель: Белушкин А.В.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 21">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Актовый зал</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 14px;">Секция 1.2: </b>
                    <b class="prog-text" style="font-size: 16px;">«Синхротронные и нейтронные исследования (разработки) в области живых систем, органических и гибридных материалов»</b>
                    <br>
                    <p class="prog-text ml-6">Председатель: Самыгина В.Р.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 22">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Студия Театральная</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 14px;">Секция 1.5: </b>
                    <b class="prog-text" style="font-size: 16px;">«Развитие ускорительных, реакторных технологий, приборноинструментальной базы для оснащения экспериментальных станций источников синхротронного излучения и нейтронов»</b>
                    <br>
                    <p class="prog-text ml-6">Председатель: Корчуганов В.Н.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 23">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Студия Интеллектуальных игр</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">14:00 - 15:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Перерыв</b>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">15:00 - 17:40</b>
                </v-chip>
              </v-col>
              <v-col>
                <!-- <b class="prog-text" style="font-size: 16px;">Секция 2: </b>
                <b class="prog-text" style="font-size: 16px;">«Научные результаты, полученные на экспериментальных станциях источников синхротронного излучения и нейтронов»</b>
                <br> -->
                <v-row>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 14px;">Секция 1.1: </b>
                    <b class="prog-text" style="font-size: 16px;">Синхротронные и нейтронные исследования (разработки) в области материаловедения для развития наукоемких производственных технологий [материалы и изделия для ядерной и термоядерной энергетики, термоэлектрических и сверхпроводящих материалов]</b>
                    <br>
                    <p class="prog-text ml-6">Председатель: Белушкин А.В.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 24">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Актовый зал</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 14px;">Секция 1.2: </b>
                    <b class="prog-text" style="font-size: 16px;">«Синхротронные и нейтронные исследования (разработки) в области живых систем, органических и гибридных материалов»</b>
                    <br>
                    <p class="prog-text ml-6">Председатели: Новикова Н.Н.и Петухов М.В.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 25">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Студия Театральная</b>
                    </div>
                  </v-col>
                  <v-col lg="4">
                    <b class="prog-text" style="font-size: 14px;">Секция 1.5: </b>
                    <b class="prog-text" style="font-size: 16px;">«Развитие ускорительных, реакторных технологий, приборноинструментальной базы для оснащения экспериментальных станций источников синхротронного излучения и нейтронов»</b>
                    <br>
                    <p class="prog-text ml-6">Председатель: Корчуганов В.Н.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 26">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Студия Интеллектуальных игр</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">17:40 - 18:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Kофе-брейк</b>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">18:00 - 19:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Постерная сессия</b>
                <v-btn 
                      small 
                      class='pa-2 ml-5'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 29">подробнее
                    </v-btn>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :key="3">
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">10:00 - 12:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <b class="prog-text" style="font-size: 14px;">Секция 1.1: </b>
                    <b class="prog-text" style="font-size: 16px;">«Синхротронные и нейтронные исследования (разработки) в области материаловедения для развития наукоемких производственных технологий [материалы и наноразмерные структуры для перспективных технологий и технических систем]»</b>
                    <br>
                    <p class="prog-text ml-6">Председатель: Мухамеджанов Э.Х.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 31">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">актовый зал</b>
                    </div>
                  </v-col>
                  <v-col>
                    <b class="prog-text" style="font-size: 14px;">Секция 1.4: </b>
                    <b class="prog-text" style="font-size: 16px;">«Технологии ядерной медицины»</b>
                    <br>
                    <p class="prog-text ml-6">Председатели: Алиев Р.А. и Сергунова К.А.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 32">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Студия Театральная</b>
                    </div>
                  </v-col>
                  <v-col>
                    <b class="prog-text" style="font-size: 16px;">Молодежная научная школа «Комплементарные аналитические методы, в том числе синхротронно-нейтронные, в исследованиях и научной реставрации объектов культурного наследия»</b>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Студия Интеллектуальных игр</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">12:00 - 12:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Кофе-брейк</b>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">12:30 - 14:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col>
                    <b class="prog-text" style="font-size: 14px;">Секция 1.1: </b>
                    <b class="prog-text" style="font-size: 16px;">«Материалы и наноразмерные структуры для перспективных технологий и технических систем»</b>
                    <br>
                    <p class="prog-text ml-6">Председатель: Мухамеджанов Э.Х.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 31">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">актовый зал</b>
                    </div>
                  </v-col>
                  <v-col>
                    <b class="prog-text" style="font-size: 14px;">Секция 1.4: </b>
                    <b class="prog-text" style="font-size: 16px;">«Технологии ядерной медицины»</b>
                    <br>
                    <p class="prog-text ml-6">Председатели: Алиев Р.А. и Сергунова К.А.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 32">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Студия Театральная</b>
                    </div>
                  </v-col>
                  <v-col>
                    <b class="prog-text" style="font-size: 16px;">Молодежная научная школа «Комплементарные аналитические методы, в том числе синхротронно-нейтронные, в исследованиях и научной реставрации объектов культурного наследия»</b>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Студия Интеллектуальных игр</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">14:00 - 15:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Перерыв</b>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">15:00 - 18:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <!-- <b style="color:rgb(4, 43, 75); font-size: 16px; font-style: italic;">Секция 2: </b>
                <b style="color:rgb(4, 43, 75); font-size: 16px;">«Научные результаты, полученные на экспериментальных станциях источников синхротронного излучения и нейтронов»</b>
                <br> -->
                <v-row>
                  <v-col>
                    <b class="prog-text" style="font-size: 14px;">Секция 1.1: </b>
                    <b class="prog-text" style="font-size: 16px;">«Синхротронные и нейтронные исследования (разработки) в области материаловедения для развития наукоемких производственных технологий [метрологический контроль и сертификация]»</b>
                    <br>
                    <p class="prog-text ml-6">Председатель: Мухамеджанов Э.Х.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 34">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">актовый зал</b>
                    </div>
                  </v-col>
                  <v-col>
                    <b class="prog-text" style="font-size: 14px;">Микросимпозиум 1: </b>
                    <b class="prog-text" style="font-size: 16px;">«Разработка научной программы развития нейтронной исследований в Российской Федерации»</b>
                    <br>
                    <p class="prog-text ml-6">Модераторы: Благов А.Е. и Белушкин А.В.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 35">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Студия Театральная</b>
                    </div>
                  </v-col>
                  <v-col>
                    <b class="prog-text" style="font-size: 14px;">Секция 1.3: </b>
                    <b class="prog-text" style="font-size: 16px;">«Синхротронные и нейтронные исследования (разработки) в области социогуманитарных наук»</b>
                    <br>
                    <p class="prog-text ml-6">Председатель: Терещенко Е.Ю.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 36">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Студия Интеллектуальных игр</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">17:00 - 18:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Постерная сессия</b>
                <v-btn 
                  small 
                  class='pa-2 ml-5'
                  style="width:170px; " 
                  color="red" 
                  outlined
                  @click="details_modal = true; details_type = 39">подробнее
                </v-btn>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :key="4">
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">10:00 - 13:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <!-- <b style="color:rgb(4, 43, 75); font-size: 16px; font-style: italic;">Секция 2: </b>
                <b style="color:rgb(4, 43, 75); font-size: 16px;">«Научные результаты, полученные на экспериментальных станциях источников синхротронного излучения и нейтронов»</b>
                <br> -->
                    <b class="prog-text" style="font-size: 16px;">«Молодежная научная школа «Комплементарные аналитические методы, в том числе синхротронно-нейтронные, в исследованиях и научной реставрации объектов культурного наследия»</b>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Студия Интеллектуальных игр</b>
                    </div>
              </v-col>
            </v-row>
            <hr>
            <hr>

            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">09:00 - 10:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col lg-6>
                    <b class="prog-text" style="font-size: 14px;">Круглый стол: </b>
                    <b class="prog-text" style="font-size: 16px;">«Промышленное применение установок мегакласса. Разработка научной программы проекта ТНК «Зеленоград»</b>
                    <br>
                    <p class="prog-text ml-6">Модератор: Благов А.Е.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 41">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Студия Театральная</b>
                    </div>
                  </v-col>
                  <v-col lg-6>
                    <b class="prog-text" style="font-size: 14px;">Микросимпозиум 2: </b>
                    <b class="prog-text" style="font-size: 16px;">«Разработка научной программы мегаустановки РИФ»</b>
                    <br>
                    <p class="prog-text ml-6">Модератор: Звонарёв С.В. </p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 42">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Студия Художественная</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">10:30 - 11:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Кофе-брейк</b>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">11:00 - 13:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 16px;">Сессия 2: </b>
                <b class="prog-text" style="font-size: 16px;">«Концепция и научная программа синхротронно-лазерного комплекса "СИЛА"»</b>
                <v-row>
                  <v-col>
                    <b class="prog-text" style="font-size: 14px;">Секция 2.1: </b>
                    <b class="prog-text" style="font-size: 16px;">«Концептуальные проекты и научные программы экспериментальных станций первой очереди источника СИ»</b>
                    <br>
                    <p class="prog-text ml-6">Председатели: Благов А.Е. и  Якунин С.Н.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 43">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Актовый зал</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">13:30 - 14:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b  class="prog-text">Перерыв</b>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">14:30 - 16:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <v-row>
                  <v-col lg-6>
                    <b class="prog-text" style="font-size: 14px;">Секция 2.1: </b>
                    <b class="prog-text" style="font-size: 16px;">«Концептуальные проекты и научные программы экспериментальных станций первой очереди источника СИ» (продолжение)</b>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 44">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Актовый зал</b>
                    </div>
                  </v-col>
                  <v-col lg-6>
                    <b class="prog-text" style="font-size: 14px;">Круглый стол: </b>
                    <b class="prog-text" style="font-size: 16px;">«Совместная подготовка кадров для развития синхротронных и нейтронных исследований»</b>
                    <br>
                    <p class="prog-text ml-6">Модератор: Карпухин А.В.</p>
                    <v-btn 
                      small 
                      class='pa-2'
                      style="width:170px; " 
                      color="red" 
                      outlined
                      @click="details_modal = true; details_type = 48">подробнее
                    </v-btn>
                    <div style="text-align: right;">
                      <b style="font-style: italic; color: gray;">Студия Театральная</b>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">16:00 - 16:30</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text">Кофе-брейк</b>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">16:30 - 17:50</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 14px;">Секция 2.2: </b>
                <b class="prog-text" style="font-size: 16px;">«Концептуальные проекты и научные программы экспериментальных станций первой очереди лазера на свободных электронах»</b>
                <br>
                <p class="prog-text ml-6">Председатели: Благов А.Е. и Носик В.Л.</p>
                <v-btn 
                  small 
                  class='pa-2'
                  style="width:170px; " 
                  color="red" 
                  outlined
                  @click="details_modal = true; details_type = 45">подробнее
                </v-btn>
                <div style="text-align: right;">
                  <b style="font-style: italic; color: gray;">Актовый зал</b>
                </div>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                <v-chip :color="$mainColor" text-color="white">
                  <v-avatar left>
                    <v-icon color="white">mdi-clock-time-eight</v-icon>
                  </v-avatar>
                  <b style="color:white;">17:50 - 18:00</b>
                </v-chip>
              </v-col>
              <v-col>
                <b class="prog-text" style="font-size: 18px;">Закрытие Форума</b>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>


        <!-- <p>
        <b>Работа форума будет осуществляться по трем секциям и двум микросимпозиумам:</b>
      </p>
      <ul>
        <li><b>Секция 1</b> – Перспективные синхротронные и нейтронные исследования</li>
        <li><b>Секция 2</b> – Научные результаты, полученные на экспериментальных станциях Курчатовского комплекса синхротронно-нейтронных исследований</li>
        <li class="ml-5"><i>Подсекция 2.1</i> – Материаловедение</li>
        <li class="ml-5"><i>Подсекция 2.2</i> – Биология и науки о жизни</li>
        <li class="ml-5"><i>Подсекция 2.3</i> – Культурное наследие</li>
        <li><b>Секция 3</b> – Концепция и научная программа синхротронно-лазерного комплекса «СИЛА»</li>
        <li class="ml-5"><i>Подсекция 3.1</i> – Концептуальные проекты и научные программы экспериментальных станций первой очереди источника СИ</li>
        <li class="ml-5"><i>Подсекция 3.2</i> – Концептуальные проекты и научные программы экспериментальных станций первой очереди лазера на свободных электронах</li>
        <li><b>Микросимпозиум 1</b> – Разработка научной программы развития нейтронных исследований в Российской Федерации</li>
        <li><b>Микросимпозиум 2</b> – Научная программы проектов «РИФ» и ТНК «Зеленоград»</li>
        <li><b>Круглый стол</b> – Промышленное применение установок мегакласса</li>
        <li><b>Круглый стол</b> – Совместная подготовка кадров  для развития синхротронных и нейтронных исследований</li>
      </ul>         -->

      <!-- <p class="mt-2">
        Также в рамках Совещания пользователей запланировано проведение <b>круглого стола</b> «Программа развития исследовательских возможностей Курчатовского комплекса синхротронно-нейтронных исследований»
      </p> -->

      </v-card>


    <v-dialog v-model="details_modal" max-width="60%">
      <v-card class="pa-2">
        <div v-if="details_type == 1">
          <v-card-title class="headline">ПЛЕНАРНЫЕ ВЫСТУПЛЕНИЯ
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <p class="prog-text" style="font-size: 16px;"><b>«Синхротроны 4 поколения и лазеры на свободных электронах – взгляд в будущее»</b></p>
            <p class="prog-text ml-6"><b>Благов А.Е.</b> вице-президент НИЦ «Курчатовский институт»</p>
            <hr>
            <p class="prog-text" style="font-size: 16px;"><b>«Современные задачи для нейтронных исследований с учетом запуска реакторного комплекса ПИК»</b></p>
            <p class="prog-text ml-6"><b>Белушкин А.В.</b> заместитель руководителя Курчатовского комплекса синхротронно-нейтронных исследований по научной работе НИЦ «Курчатовский институт»</p>
            <hr>
            <p class="prog-text" style="font-size: 16px;"><b>«О текущем статусе СКИФ»</b></p>
            <p class="prog-text ml-6"><b>Бухтияров В.И.</b> директор Института катализа СО РАН</p>
          </v-card-text>
        </div>

        <div v-if="details_type == 21">
          <v-card-title class="headline">
            <p>СИНХРОТРОННЫЕ И НЕЙТРОННЫЕ ИССЛЕДОВАНИЯ (РАЗРАБОТКИ) В ОБЛАСТИ МАТЕРИАЛОВЕДЕНИЯ ДЛЯ РАЗВИТИЯ НАУКОЕМКИХ ПРОИЗВОДСТВЕННЫХ ТЕХНОЛОГИЙ [КОНСТРУКЦИОННЫЕ МАТЕРИАЛЫ]</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">12:00 - 12:20</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Денисов В.В.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«In situ методы синхротронных исследований многослойных функциональных структур с уникальными параметрами и свойствами, созданных пучково- плазменной инженерией поверхности»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">12:20 - 12:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Горбовец М.А.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Создание научных и методологических основ использования синхротронного и нейтронного излучения для разработки прорывных промышленных технологий структурной диагностики металлических и металлокерамических материалов, синтезированных аддитивными технологиями»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">12:40 - 12:55</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Иванов С.Ю.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Особенности формирования поля остаточных напряжений в образцах, полученных методом прямого лазерного выращивания»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">12:55 - 13:10</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Сундеев Р.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Применение синхротронного излучения для исследования локальной атомной структуры неравновесных фазовых состояний, полученных методами экстремальных воздействий»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:10 - 13:25</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Рогожкин С.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Малоугловое рассеяние нейтронов и комплементарный анализ наноструктуры дисперсно-упрочненных оксидами сталей»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:25 - 13:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Таркаева Е.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Напыление аморфных пленок оксида ванадия электронным лучом в кислородной атмосфере»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:40 - 13:55</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Лушников С.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Структура гидридных фаз на основе интерметаллидов и высокоэнтропийных сплавов»</b></p>
              </v-col>
            </v-row>
          </v-card-text>
        </div>

        <div v-if="details_type == 22">
          <v-card-title class="headline">
            <p>СИНХРОТРОННЫЕ И НЕЙТРОННЫЕ ИССЛЕДОВАНИЯ (РАЗРАБОТКИ) В ОБЛАСТИ ЖИВЫХ СИСТЕМ, ОРГАНИЧЕСКИХ И ГИБРИДНЫХ МАТЕРИАЛОВ</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">12:00 - 12:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Попов В.О.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Разработка научно- методической базы для проведения исследований и подготовки кадров при решении структурных и динамических задач фундаментальной и прикладной биологии с использованием современных источников рентгеновского излучения и нейтронов»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">12:30 - 13:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Агафонов А.П.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Использование синхротронного излучения для вирусологических исследований»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:00 - 13:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Каприн А.Д.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Персонализированные стратегии лечения онкологических заболеваний с помощью нейтронного излучений на основе трехмерных клеточных моделей опухолей»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:30 - 14:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Костров С.В.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Разработка новых гибридных, природоподобных материалов на основе полимеров и композитов с оптимизированной структурой и включающих иннервирующий биологический компонент, для элементов биоробототехнических устройств»</b></p>
              </v-col>
            </v-row>
          </v-card-text>
        </div>

        <div v-if="details_type == 23">
          <v-card-title class="headline">
            <p>РАЗВИТИЕ УСКОРИТЕЛЬНЫХ, РЕАКТОРНЫХ ТЕХНОЛОГИЙ, ПРИБОРНО-ИНСТРУМЕНТАЛЬНОЙ БАЗЫ ДЛЯ ОСНАЩЕНИЯ ЭКСПЕРИМЕНТАЛЬНЫХ СТАНЦИЙ ИСТОЧНИКОВ СИНХРОТРОННОГО ИЗЛУЧЕНИЯ И НЕЙТРОНОВ</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">12:00 - 12:20</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Кулевой Т.В.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Разработка компактных источников фотонов и нейтронов на базе новых технологий линейных ускорителей - основных элементов лазера на свободных электронах и импульсных нейтронных источниках»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">12:20 - 12:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Золотарёв К.В.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Новые подходы к созданию источников синхротронного излучения»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">12:40 - 13:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Стародубцев М.В.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Новые источники синхротронного излучения и нейтронов на принципах лазерного ускорения заряженных частиц»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:00 - 13:20</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Просеков П.А.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Разработка элементов и систем экспериментальных станций источников синхротронного излучения для комплементарных in situ исследований динамики трансформации объектов в условиях внешних воздействий в целях разработки, создания и диагностики новых материалов»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:20 - 13:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Солдатов А.В.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Управляемая искусственным интеллектом роботизированная станция на источнике синхротронного излучения для ускоренной разработки новых перспективных материалов и их диагностики в режиме реального времени»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:40 - 14:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Боднарчук В.И.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Разработка и создание элементов экспериментальных станций на источниках нейтронов импульсного или постоянного типа»</b></p>
              </v-col>
            </v-row>
          </v-card-text>
        </div>

        <div v-if="details_type == 24">
          <v-card-title class="headline">
            <p>СИНХРОТРОННЫЕ И НЕЙТРОННЫЕ ИССЛЕДОВАНИЯ (РАЗРАБОТКИ) В ОБЛАСТИ МАТЕРИАЛОВЕДЕНИЯ ДЛЯ РАЗВИТИЯ НАУКОЕМКИХ ПРОИЗВОДСТВЕННЫХ ТЕХНОЛОГИЙ [МАТЕРИАЛЫ И ИЗДЕЛИЯ ДЛЯ ЯДЕРНОЙ И ТЕРМОЯДЕРНОЙ ЭНЕРГЕТИКИ, ТЕРМОЭЛЕКТРИЧЕСКИХ И СВЕРХПРОВОДЯЩИХ МАТЕРИАЛОВ]</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:00 - 15:20</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Кузнецов А.П.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Методы синхротронной и нейтронной диагностики материалов ядерной, термоядерной энергетики и сверхпроводящих материалов»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:20 - 15:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Романчук А.Ю.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Развитие синхротронных и нейтронных исследований и инфраструктуры для материалов энергетики нового поколения и безопасного захоронения радиоактивных отходов»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:40 - 15:55</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Митюшев Н.Д.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Разработка фотомемристивных устройств на основе модифицированного оксида графена и перспективы синхротронных исследований их фотоэлектронных переходов»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:55 - 16:10</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Дрожжин О.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Синхротронные методы в operando режиме для изучения структурных и зарядовых трансформаций в материалах для металл-ионных аккумуляторов»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:10 - 16:25</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Сивков В.Н.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Определение сечений поглощения СИ в области NEXAFS на канале НаноФЭС»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:25 - 16:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Менушенков А.П.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«EXAFS и XANES спектроскопия высокотемпературных сверхповодников»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:40 - 16:55</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Матвеев П.И.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«EXAFS-спектроскопия для исследования координационных соединений актинидов в органической фазе»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:55 - 17:10</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Гаспарян Ю.М.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Исследование материалов термоядерных реакторов методами синхротронной и нейтронной диагностики»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">17:10 - 17:25</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Романчук А.Ю.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Окислительно-восстановительные реакции плутония и его аналогов при сорбции на минералах»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">17:25 - 17:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Сараев А.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Фотокатализаторы восстановления CO2 на основе TiO2: XAS исследование»</b></p>
              </v-col>
            </v-row>
          </v-card-text>
        </div>

        <div v-if="details_type == 25">
          <v-card-title class="headline">
            <p>СИНХРОТРОННЫЕ И НЕЙТРОННЫЕ ИССЛЕДОВАНИЯ (РАЗРАБОТКИ) В ОБЛАСТИ ЖИВЫХ СИСТЕМ, ОРГАНИЧЕСКИХ И ГИБРИДНЫХ МАТЕРИАЛОВ</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:00 - 15:20</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Швецов А.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Совместное использование методов молекулярной динамики, МУРН и МУРР»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:20 - 15:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Самыгина В.Р.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Структурные исследования бета-галактозидазы Desulfurococcus amyloliticus»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:40 - 16:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Горшкова Ю.Е.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Инновационные биокомпозиты для регенеративной медицины»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:00 - 16:20</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Петухов М.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Структурный анализ вирионов ряда растительных вирусов по данным малоуглового рентгеновского рассеяния»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:20 - 16:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Новикова Н.Н.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Применение синхротронного излучения для исследований слабоупорядоченных наносистем на поверхности жидкости»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:40 - 17:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Усачёв К.С.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Анализ данных рентгеноструктурного анализа комплексов эукариотической рибосомы с низкомолекулярными ингибиторами, индуцирующими прочтение стоп-кодонов»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">17:00 - 17:20</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Шайтан К.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Технологии искусственного интеллекта для анализа дифракционных паттернов биополимеров и их комплексов»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">17:20 - 17:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Дадинова Л.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Структура геном-защитных биокристаллов по данным малоуглового рентгеновского рассеяния и крио-электронной микроскопии»</b></p>
              </v-col>
            </v-row>
          </v-card-text>
        </div>

        <div v-if="details_type == 26">
          <v-card-title class="headline">
            <p>РАЗВИТИЕ УСКОРИТЕЛЬНЫХ, РЕАКТОРНЫХ ТЕХНОЛОГИЙ, ПРИБОРНО-ИНСТРУМЕНТАЛЬНОЙ БАЗЫ ДЛЯ ОСНАЩЕНИЯ ЭКСПЕРИМЕНТАЛЬНЫХ СТАНЦИЙ ИСТОЧНИКОВ СИНХРОТРОННОГО ИЗЛУЧЕНИЯ И НЕЙТРОНОВ</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:00 - 15:15</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Фомин Е.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Новый источник синхротронного излучения КИСИ-2»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:15 - 15:45</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Сараев А.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Научная программа ЦКП СКИФ»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:45 - 16:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Сыртанов М.С.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Создание Томского центра компетенций в области пучково-плазменной инженерии и синхротронных исследований»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:00 - 16:15</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Попов А.И.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Моделирование нейтроноводов для перспективных источников нейтронов»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:15 - 16:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Колачевский Н.Н.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Перспективные ядерно-физические технологии на базе синхротронного комплекса ФИАН»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:30 - 16:45</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Седов А.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Разработка сверхпроводящего вигглера с полем 2.7 Тл и периодом 27 мм для станции «Быстропротекающие процессы» на источнике СКИФ»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:45 - 17:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Снигирёв А.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Когерентная рентгеновская оптика для источников 4-го поколения»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">17:00 - 17:15</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Полозов С.М.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Ход разработки фотопушки для линейного ускорителя-инжектора проекта «СИЛА»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">17:15 - 17:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Саган К.С.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Изучение нелинейных эффектов и неустойчивостей в накопительном кольце комплекса «СИЛА»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">17:30 - 17:45</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Смоляков Н.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Характеристики излучения из планируемых ондуляторов источника «СИЛА»»</b></p>
              </v-col>
            </v-row>
          </v-card-text>
        </div>

        <div v-if="details_type == 29">
          <v-card-title class="headline">
            <p>ПОСТЕРНАЯ СЕССИЯ (25 октября 18:00-19:00)</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">46</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Акимова Ольга Владимировна</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">123</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Амиров Абдулкарим Абдулнатипович</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">41</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Арбанас Левко Андреевич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">65</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Астафьев Александр Леонидович</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">59</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Баранников Александр Александрович</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">61</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Беликов Евгений Александрович</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">69</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Верлов Николай Александрович</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">63</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Глушко Александр Александрович</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">48</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Гордиенко Александр Максимович</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">55</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Горячевский Александр Владимирович</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">78</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Денисов Владимир Викторович</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">45</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Казанцев Федор Павлович</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">54</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Клочков Никита Сергеевич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">73</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Корбан Светлана Андреевна</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">60</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Коротков Александр Сергеевич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">67</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Коротков Александр Сергеевич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">57</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Лаврушин Георгий Михайлович</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">71</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Лис Ольга Николаевна</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">64</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Лысенко Виктория Юрьевна</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">126</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Лятун Иван Игоревич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">77</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Меренцов Александр Ильич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">72</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Муфтахова Лия Рустемовна</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">121</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Нарикович Антон Сергеевич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">51</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Омельченко Александр Иванович</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">47</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Павлычев Андрей Алексеевич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">75</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Пацаев Тимофей Дмитриевич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">52</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Петренко Дмитрий Евгеньевич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">56</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Сафонов Антон Игоревич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">44</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Свечников Николай Юрьевич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">43</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Сенкевич Артем Андреевич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">42</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Смыслов Руслан Юрьевич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">127</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Сороковиков Михаил Николаевич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">76</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Срабионян Василий Валерьевич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">66</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Сухарина Галина Борисовна</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">68</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Тимофеев Владимир Игоревич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">50</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Третьякова Анастасия Никитична</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">53</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Усачев Константин Сергеевич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">74</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Федосеев Михаил Леонидович</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">58</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Фоломешкин Максим Сергеевич</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">49</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Цвигун Наталья Викторовна</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 120px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-billboard</v-icon>
                    </v-avatar>
                    <b style="color:white;">70</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Шрамков Егор Александрович</b></p>
              </v-col>
            </v-row>
          </v-card-text>
        </div>

        <div v-if="details_type == 31">
          <v-card-title class="headline">
            <p>СИНХРОТРОННЫЕ И НЕЙТРОННЫЕ ИССЛЕДОВАНИЯ (РАЗРАБОТКИ) В ОБЛАСТИ МАТЕРИАЛОВЕДЕНИЯ ДЛЯ РАЗВИТИЯ НАУКОЕМКИХ ПРОИЗВОДСТВЕННЫХ ТЕХНОЛОГИЙ [МАТЕРИАЛЫ И НАНОРАЗМЕРНЫЕ СТРУКТУРЫ ДЛЯ ПЕРСПЕКТИВНЫХ ТЕХНОЛОГИЙ И ТЕХНИЧЕСКИХ СИСТЕМ]</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">10:00 - 10:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Романов А.Е.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Рентгеновские лазерные технологии в нано- и биоматериаловедении»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">10:30 - 11:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Рындина Т.С.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Разработка и исследование перспективных материалов и наноструктур для технологии безмасочной рентгеновской нанолитографии, применимой к созданию новой компонентной базы микро- и наноэлектроники с использованием источника синхротронного излучения»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">11:00 - 11:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Турищев С.Ю.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Распределенная инфраструктура высокоточных методов диагностики в ультрамягкой рентгеновской области синхротронного излучения для функциональных материалов и наноразмерных структур, включая био-нано-гибридные, для перспективных технологий и технических систем: от образовательных технологий через фундаментальные научные исследования к практическому применению»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">11:30 - 11:45</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Андреева М.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Синхротронная мессбауэровская рефлектометрия в исследовании ультратонких пленок YFeO3»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">11:45 - 12:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Авдеев М.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Структурная характеризация феррожидкостей с применением малоуглового рассеяния СИ и нейтронов»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">12:00 - 12:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">12:30 - 12:45</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Титов А.Н.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Равновесные нанослои в твёрдых растворах слоистых дихалькогенидов переходных металлов»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">12:45 - 13:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Овсянников А.С.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Рациональный дизайн кристаллических функциональных материалов на основе d-/f- комплексов (тиа)каликс[4]аренов»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:00 - 13:15</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Карпюк П.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Использование синхротронного излучения для исследования примесных атомов в матрицах со структурой граната общего состава (Gd,Y)3Al2Ga3O12»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:15 - 13:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Бойцова О.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Слоистые углеродсодержащие материалы – влияние термической постобработки на функциональные свойства»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:30 - 13:45</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Копица Г.П.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«К вопросу о надмолекулярной структуре бактериальной целлюлозы,  синтезированной в тяжёлой воде»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:45 - 14:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Сутурин С.М.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Исследования сверхбыстрой динамики магнитных флуктуаций с помощью рентгеновского лазера на свободных электронах»</b></p>
              </v-col>
            </v-row>
          </v-card-text>
        </div>

        <div v-if="details_type == 32">
          <v-card-title class="headline">
            <p>ТЕХНОЛОГИИ ЯДЕРНОЙ МЕДИЦИНЫ</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">10:00 - 10:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Важенина Д.А.</b> Приглашённый</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Перспективные радионуклиды и радиофармпрпараты для тераностики онкологических заболеваний»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">10:30 - 11:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Шегай П.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Опыт импортозамещения в производстве отечественных радиофармацевтических лекарственных препаратов и радиотерапевтического оборудования»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">11:00 - 11:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Сергунова К.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Создание Новейшего научно-образовательного медицинского центра ядерной медицины в рамках Федеральной научно-технической программы развития синхротронных и нейтронных исследований и исследовательской инфраструктуры на 2019 – 2027 годы»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">11:30 - 12:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Коневега А.Л.</b> Приглашённый (в рамках ПП РФ№ 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Разработка отечественного инновационного тераностического препарата на основе изотопов тербия для проведения радиоиммунной терапии злокачественных новообразований различного гистологического типа»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">12:00 - 12:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">12:30 - 13:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Завестовская И.Н.</b> Приглашённый (в рамках ПП РФ№ 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Разработка новых технологий диагностики и лучевой терапии социально значимых заболеваний протонными и ионными пучками с использованием бинарных ядерно-физических методов»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:00 - 13:20</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Ларенков А.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Разработка радиофармацевтических лекарственных препаратов: от первичного поиска до обеспечения качества готовой лекарственной формы»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:20 - 13:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Чувилин Д.Ю.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Получение на исследовательском реакторе ИР-8 радионуклида 177Lu и разработка на его основе радиофармпрепарата для терапии онкологических заболеваний»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:40 - 14:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Фуркина Е.Б.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Получение перспективных медицинских радионуклидов в НИЦ «Курчатовский институт»</b></p>
              </v-col>
            </v-row>
          </v-card-text>
        </div>

        <div v-if="details_type == 34">
          <v-card-title class="headline">
            <p>СИНХРОТРОННЫЕ И НЕЙТРОННЫЕ ИССЛЕДОВАНИЯ (РАЗРАБОТКИ) В ОБЛАСТИ МАТЕРИАЛОВЕДЕНИЯ ДЛЯ РАЗВИТИЯ НАУКОЕМКИХ ПРОИЗВОДСТВЕННЫХ ТЕХНОЛОГИЙ [МЕТРОЛОГИЧЕСКИЙ КОНТРОЛЬ И СЕРТИФИКАЦИЯ]</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:00 - 15:20</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Батурин А.С.</b> Приглашённый (в рамках ПП РФ № 951)</p>
                <p class="prog-text" style="font-size: 14px;"><b>«Разработка и развитие основных элементов государственной системы обеспечения единства измерений на источниках синхротронного излучения для контроля качества ключевых узлов и деталей изделий промышленности с международным признанием результатов»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:20 - 15:35</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Дарьин Ф.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Микро-, нанофокусное СИ в геологии, опыт и перспективы развития»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:35 - 15:50</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Солдатов М.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«in situ диагностика наноразмерных материалов на станции структурного материаловедения Курчатовского синхротрона»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:50 - 16:05</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Бакиров Б.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Новые алгоритмы обработки данных нейтронной томографии на основе сверточных нейронных сетей»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:05 - 16:20</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Николаев К.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Корректировка ошибок в нано-метрологических исследованиях на примере метода стоячих рентгеновских волн»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:20 - 16:35</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Мареев Е.И.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Синхротронная времяразрешающая методика регистрации лазерно-индуцированных деформаций, и ее реализация для наблюдения»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:35 - 16:50</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Иванов Д.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Сочетание микрофокусного рентгеновского рассеяния и сверхбыстрой калориметрии на чипе на установках мегасайенс»</b></p>
              </v-col>
            </v-row>
          </v-card-text>
        </div>

        <div v-if="details_type == 35">
          <v-card-title class="headline">
            <p>РАЗРАБОТКА НАУЧНОЙ ПРОГРАММЫ РАЗВИТИЯ НЕЙТРОННЫХ ИССЛЕДОВАНИЙ В РОССИЙСКОЙ ФЕДЕРАЦИИ</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:00 - 15:20</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Воронин В.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Программа исследований на реакторе ПИК»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:20 - 15:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Тарнавич В.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Состояние работ по созданию нейтронных установок для физики конденсированного состояния на реакторном комплексе ПИК»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:30 - 15:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Зобкало И.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Научные направления в области физики конденсированного состояния на РК ПИК»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:40 - 16:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Эм В. Т.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Научная программа ИР- 8»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:00 - 16:10</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Мурашев М. М.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Исследования изделий аддитивных производств из функционально-градиентных материалов методами нейтронной визуализации»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:10 - 16:20</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Карпов И.Д.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Нейтронно-дифракционные исследования остаточных напряжений вблизи поверхности»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:20 - 16:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Лычагин Е.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Научная программа ИБР-2»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:40 - 17:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Губкин А.Ф.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Исследования в нейтронном материаловедческом комплексе ИФМ УрО РАН»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">17:00 - 17:20</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Колесников Я.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Ускорительный источник нейтронов VITA для проведения нейтронных исследований»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">17:20 - 17:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Константинов В.Л.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Программа перспективных экспериментальных исследований на реакторной установке МБИР в период с 2028 по 2040 годы»</b></p>
              </v-col>
            </v-row>
          </v-card-text>
        </div>

        <div v-if="details_type == 36">
          <v-card-title class="headline">
            <p>СИНХРОТРОННЫЕ И НЕЙТРОННЫЕ ИССЛЕДОВАНИЯ (РАЗРАБОТКИ) В ОБЛАСТИ СОЦИОГУМАНИТАРНЫХ НАУК</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:00 - 15:15</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Шалявина Н.Б.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Исследование и реконструкция полихромной росписи лекифа IV в. до н.э.»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:15 - 15:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Тарасенко К.К.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Исследование ископаемых морских млекопитающих с помощью синхротронной и нейтронной томографии: результаты и перспективы»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:30 - 15:45</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Пахневич А.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Исследование палеонтологических объектов с помощью синхротронной и нейтронной томографии»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:45 - 16:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Кравцова Н.Г.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Две терракотовые плиты из ГМИИ им. А.С. Пушкина»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:00 - 16:15</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Мандрыкина А.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Комплексные исследования каменных артефактов Дальнего Востока»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:15 - 16:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Антипенко А.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Драгоценный металл средневековых городов Крыма»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:30 - 17:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>кофе-брейк</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">17:00 - 17:15</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Кузнецова В.П.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Роль физико-химических исследований в научной реставрации археологических предметов»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">17:15 - 17:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Грешников Э.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Исследования древнерусских крестов-тельников XI-XII вв. изготовленных из сплавов системы Pb-Sn и Sn-Pb методами нейтронно-радиационного анализа и синхротронной дифракции»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">17:30 - 17:45</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Созонтов Е.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Римские монеты эпохи империи: анализ методом нейтронной томографии на Курчатовском нейтронном источнике и элементное картирование»</b></p>
              </v-col>
            </v-row>
          </v-card-text>
        </div>

        <div v-if="details_type == 39">
          <v-card-title class="headline">
            <p>ПОСТЕРНАЯ СЕССИЯ (26 октября 17:00-18:30)</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <div v-for="item in items_26" :key="item.id">
              <v-row>
                <v-col style="max-width: 120px !important;">
                    <v-chip :color="$mainColor" text-color="white">
                      <v-avatar left>
                        <v-icon color="white">mdi-billboard</v-icon>
                      </v-avatar>
                      <b style="color:white;">{{ item.stend }}</b>
                    </v-chip>
                  </v-col>
                <v-col>
                  <p class="prog-text ml-6" style="font-size: 18px;"><b>{{ item.descr }}</b></p>
                  <p class="prog-text ml-12" style="font-size: 14px;">{{ item.st_name }}</p>
                </v-col>
              </v-row>
              <hr>
            </div>
          </v-card-text>
        </div>

        <div v-if="details_type == 41">
          <v-card-title class="headline">
            <p>Круглый стол: «ПРОМЫШЛЕННОЕ ПРИМЕНЕНИЕ УСТАНОВОК МЕГАКЛАССА. РАЗРАБОТКА НАУЧНОЙ ПРОГРАММЫ ПРОЕКТА ТНК «ЗЕЛЕНОГРАД»»</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">09:00 - 09:25</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Марченков Никита Владимирович</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Современные методы применения СИ в различных отраслях промышленности»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">09:25 - 09:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Носик Валерий Леонидович</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Современное состояние EUV-литографии в мире»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">09:40 - 10:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Дюжев Николай Алексеевич</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Перспективы развития рентгеновской литографии в РФ. Проект «Рентгеновский литограф»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">10:00 - 10:10</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Гончаренко Михаил Сергеевич</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Модернизация и ввод в эксплуатацию ТНК «Зеленоград»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">10:10 - 10:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>ДИСКУССИЯ</b></p>
              </v-col>
            </v-row>
          </v-card-text>
        </div>

        <div v-if="details_type == 42">
          <v-card-title class="headline">
            <p>Микросимпозиум: «РАЗРАБОТКА НАУЧНОЙ ПРОГРАММЫ МЕГАУСТАНОВКИ РИФ»</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">09:00 - 09:15</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Вступительное слово</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">09:15 - 09:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Папынов Евгений Константинович</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Станция спектроскопии поглощения – исследование состава и структуры для химической инженерии селективных сорбционных материалов»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">09:30 - 09:45</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Огнев Алексей Вячеславович</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Станции фотоэлектронной спектроскопии и рентгеновской дифракции – исследование электронной и спиновой структуры двумерных магнитных и топологических наносистем»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">09:45 - 10:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Буравлёв Игорь Юрьевич</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Станция визуализации – исследование и сохранение материальных объектов культурного наследия»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">10:00 - 10:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>ДИСКУССИЯ</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Солдатов А.В., Туришев С.Ю., Якунин С.Н., Велигжанин А.А., Чумаков Р.Г., Тригуб А.Л., Лазаренко В.А., Коваленко Е.С.»</b></p>
              </v-col>
            </v-row>
          </v-card-text>
        </div>

        <div v-if="details_type == 43 || details_type == 44">
          <v-card-title class="headline">
            <p>КОНЦЕПТУАЛЬНЫЕ ПРОЕКТЫ И НАУЧНЫЕ ПРОГРАММЫ ЭКСПЕРИМЕНТАЛЬНЫХ СТАНЦИЙ ПЕРВОЙ ОЧЕРЕДИ ИСТОЧНИКА СИ</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">11:00 - 11:10</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Таргонский А.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Концепция и текущий статус проекта по созданию исследовательской установки «СИЛА»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">11:10 - 11:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Серегин А.Ю.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Концептуальный проект и научная программа экспериментальной станции источника СИ «Когерентный нано-анализ»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">11:30 - 11:50</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Субботин И.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Концептуальный проект и научная программа экспериментальной станции источника СИ «Нанодифракция»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">11:50 - 12:10</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Рогачев А.В.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Концептуальный проект и научная программа экспериментальной станции источника СИ «Поверхность и интерфейсы»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">12:10 - 12:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Подурец К.М.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Концептуальный проект и научная программа экспериментальной станции источника СИ «Многомасштабная визуализация»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">12:30 - 12:50</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Лазаренко В.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Концептуальный проект и научная программа экспериментальной станции источника СИ «Серийная макромолекулярная кристаллография»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">12:50 - 13:10</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Светогоров Р.Д.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Концептуальный проект и научная программа экспериментальной станции источника СИ «Структурная кристаллография»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:10 - 13:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Лебедев А.М.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Концептуальный проект и научная программа экспериментальной станции источника СИ «Электронная спектроскопия»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">13:30 - 14:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>ПЕРЕРЫВ</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">14:30 - 14:50</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Тригуб А.Л.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Концептуальный проект и научная программа экспериментальной станции источника СИ «Спектроскопия поглощения»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">14:50 - 15:10</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Гапонов Ю.А.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Концептуальный проект и научная программа экспериментальной станции источника СИ «Малоугловое рассеяние»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:10 - 15:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Куликов А.Г.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Концептуальный проект и научная программа экспериментальной станции источника СИ «Ядерная резонансная спектроскопия»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:30 - 15:50</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Репченко Ю.Л.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Концептуальный проект и научная программа экспериментальной станции источника СИ «Магнитное рассеяние»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:50 - 16:10</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Проценко А.И.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Концептуальный проект и научная программа экспериментальной станции источника СИ «Времяразрешающая диагностика»»</b></p>
              </v-col>
            </v-row>
          </v-card-text>
        </div>

        <div v-if="details_type == 45">
          <v-card-title class="headline">
            <p>КОНЦЕПТУАЛЬНЫЕ ПРОЕКТЫ И НАУЧНЫЕ ПРОГРАММЫ ЭКСПЕРИМЕНТАЛЬНЫХ СТАНЦИЙ ПЕРВОЙ ОЧЕРЕДИ ЛАЗЕРА НА СВОБОДНЫХ ЭЛЕКТРОНАХ</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:30 - 16:50</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Макаров С.С.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Концептуальный проект и научная программа экспериментальной станции ЛСЭ «Вещество в экстремальном состоянии (ВЭкС)»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">16:50 - 17:10</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Фоломешкин М.С.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Концептуальный проект и научная программа экспериментальной станции ЛСЭ «Когерентная дифракционная визуализация (КДВ)»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">17:10 - 17:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Пиляк Ф.С.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Концептуальный проект и научная программа экспериментальной станции ЛСЭ «Времяразрешающие эксперименты (ВРЭ)»»</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row>
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">17:30 - 17:50</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Чумаков Р.Г.</b></p>
                <p class="prog-text" style="font-size: 14px;"><b>«Концептуальный проект и научная программа экспериментальной станции ЛСЭ «Электронная спектроскопия и динамика (ЭСД)»»</b></p>
              </v-col>
            </v-row>
          </v-card-text>
        </div>

        <div v-if="details_type == 48">
          <v-card-title class="headline">
            <p>Круглый стол: Совместная подготовка кадров для развития синхротронных и нейтронных исследований</p>
          </v-card-title>
          <!-- <v-card-text>Формат участия 
          </v-card-text> -->

          <v-card-text>
            <v-row  class="ml-3">
              <p class="prog-text" style="font-size: 16px;"><b>«Вступительное слово»</b></p>
            </v-row>
            <v-row class="ml-10">
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">14:30 - 14:35</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Толстикова Екатерина Андреевна</b></p>
                <!-- <p class="prog-text" style="font-size: 14px;"><b>«Современные методы применения СИ в различных отраслях промышленности»</b></p> -->
              </v-col>
            </v-row>
            <v-row class="ml-10">
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">14:35 - 14:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Афанасьев Дмитрий Владимирович</b></p>
              </v-col>
            </v-row>
            <hr>
            <v-row class="mt-6 ml-3">
              <p class="prog-text" style="font-size: 16px;"><b>«Общее состояние кадровой обеспеченности синхротронно-нейтронных исследований»</b></p>
            </v-row>
            <v-row class="ml-10">
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">14:40 - 15:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Марченков Никита Владимирович</b></p>
                <!-- <p class="prog-text" style="font-size: 14px;"><b>«Современные методы применения СИ в различных отраслях промышленности»</b></p> -->
              </v-col>
            </v-row>
            <hr>
            <v-row class="mt-6 ml-3">
              <p class="prog-text" style="font-size: 16px;"><b>«О проекте Программы подготовки кадров для обеспечения создания и функционирования уникальных научных установок: принципиально новый перспективный источник «СИЛА» (г. Протвино, Московская область) и уникальная научная установка класса «мегасайенс» «УНУ «РИФ» (о. Русский)»</b></p>
            </v-row>
            <v-row class="ml-10">
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:00 - 15:10</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Марченков Никита Владимирович</b></p>
                <!-- <p class="prog-text" style="font-size: 14px;"><b>«Современные методы применения СИ в различных отраслях промышленности»</b></p> -->
              </v-col>
            </v-row>
            <v-row class="ml-10">
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:10 - 15:20</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Пресняков Михаил Юрьевич</b></p>
                <!-- <p class="prog-text" style="font-size: 14px;"><b>«Современные методы применения СИ в различных отраслях промышленности»</b></p> -->
              </v-col>
            </v-row>
            <v-row class="ml-10">
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:20 - 15:30</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Карпухин Алексей Владимирович</b></p>
                <!-- <p class="prog-text" style="font-size: 14px;"><b>«Современные методы применения СИ в различных отраслях промышленности»</b></p> -->
              </v-col>
            </v-row>
            <v-row class="ml-10">
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:30 - 15:40</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Воронов Артем Анатольевич</b></p>
                <!-- <p class="prog-text" style="font-size: 14px;"><b>«Современные методы применения СИ в различных отраслях промышленности»</b></p> -->
              </v-col>
            </v-row>
            <hr>


            
            <v-row class="mt-6 ml-3">
              <p class="prog-text" style="font-size: 16px;"><b>«Развитие научно-технического творчества школьников в области естественных наук»</b></p>
            </v-row>
            <v-row class="ml-10">
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:40 - 15:45</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Чернышева Зоя Николаевна</b></p>
                <!-- <p class="prog-text" style="font-size: 14px;"><b>«Современные методы применения СИ в различных отраслях промышленности»</b></p> -->
              </v-col>
            </v-row>
            <v-row class="ml-10">
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:45 - 15:50</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Розов Павел Сергеевич</b></p>
                <!-- <p class="prog-text" style="font-size: 14px;"><b>«Современные методы применения СИ в различных отраслях промышленности»</b></p> -->
              </v-col>
            </v-row>
            <v-row class="ml-10">
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:50 - 15:55</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Бронштейн Илья Михайлович</b></p>
                <!-- <p class="prog-text" style="font-size: 14px;"><b>«Современные методы применения СИ в различных отраслях промышленности»</b></p> -->
              </v-col>
            </v-row>
            <v-row class="ml-10">
              <v-col style="max-width: 150px !important;">
                  <v-chip :color="$mainColor" text-color="white">
                    <v-avatar left>
                      <v-icon color="white">mdi-clock-time-eight</v-icon>
                    </v-avatar>
                    <b style="color:white;">15:55 - 16:00</b>
                  </v-chip>
                </v-col>
              <v-col>
                <p class="prog-text ml-6" style="font-size: 18px;"><b>Журавлев Андрей Валерьевич</b></p>
                <!-- <p class="prog-text" style="font-size: 14px;"><b>«Современные методы применения СИ в различных отраслях промышленности»</b></p> -->
              </v-col>
            </v-row>






          </v-card-text>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="details_modal = false">закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>    

</template>
<script>


export default {
  name: 'Program',

  data() {
    return {
      activeTab: 0,
      details_modal: false,
      details_type: 0,
      items_26: [
        {id: 	1	, descr: '	Алексеев Роман Олегович'	, stend: '	104'	, st_name: '	Строение высокопреломляющих оксидных стекол по данным спектроскопии EXAFS и XANES'	},
        {id: 	2	, descr: '	Асадчиков В.Е.'	, stend: '	119'	, st_name: '	Рентгеновская рефлектометрия липидных плёнок на жидкостях с использованием синхротронного излучения'},
        {id: 	3	, descr: '	Баулин Роман Алексеевич'	, stend: '	128	', st_name: '	Кластерно-слоистая структура в пленках [Fe/Cr], выявленная методом GISAXS и синхротронной мёссбауэровской спектроскопии'	},
        {id: 	4	, descr: '	Бойков Николай Игоревич'	, stend: '	85'	, st_name: '	Синхротронные исследования эпитаксиальных структур олово-кремний'	},
        {id: 	5	, descr: '	Васильев Вениамин Андреевич'	, stend: '	125'	, st_name: '	Исследование зависимости откручивания ДНК от нуклеосом в зависимости от последовательности и длины ДНК методом малоуглового рассеяния рентгеновского излучения.'	},
        {id: 	6	, descr: '	Волков Ю. О.'	, stend: '	118'	, st_name: 'Структура адсорбционных плёнок алканолов на границе масло-вода по данным синхротронной рентгеновской рефлектометрии'	},
        {id: 	7	, descr: '	Голубничий Александр Александрович'	, stend: '	102'	, st_name: '	Кристаллическая структура магний-замещенных слоистых оксидов лития и переходных металлов'	},
        {id: 	8	, descr: '	Еремина Рушана Михайловна'	, stend: '	79'	, st_name: '	Магнитная структура монокристаллов (Ni,Mn,Cu)3BO5'	},
        {id: 	9	, descr: '	Ермакова Александра Михайловна'	, stend: '	105'	, st_name: '	Синтез и структурные особенности сегнетоэлектрических материалов по данным рентгеновской спектроскопии'	},
        {id: 	10	, descr: '	Кравченко Галина Валерьевна'	, stend: '	86'	, st_name: '	Влияние локального окружения ионов титана на каталитические свойства титансодержащих цеолитов типа MFI'	},
        {id: 	11	, descr: '	Крот Анна Дмитриевна'	, stend: '	84'	, st_name: '	Спектроскопия рентгеновского поглощения в исследовании физико-химических форм урана'	},
        {id: 	12	, descr: '	Кузенкова Анастасия Сергеевна'	, stend: '	92'	, st_name: '	Окислительно-восстановительное поведение Pu(VI) и Pu(V) в водных растворах'	},
        {id: 	13	, descr: '	Куликова Елизавета Сергеевна'	, stend: '	114'	, st_name: '	Порошковая дифракция высокого разрешения на станции «Белок/РСА» Курчатовского источника синхротронного излучения'	},
        {id: 	14	, descr: '	Макарова Ирина Павловна'	, stend: '	100'	, st_name: '	Исследование структуры кристаллов-суперпротоников	'},
        {id: 	15	, descr: '	Матюхов Владимир Владимирович'	, stend: '	93'	, st_name: '	Синтез углеродных покрытий на наночастицах металлов'	},
        {id: 	16	, descr: '	Моисеев Иван Алексеевич'	, stend: '	103'	, st_name: '	Кристаллическая структура магний-замещенных слоистых оксидов лития и переходных металлов'	},
        {id: 	17	, descr: '	Мусатова Вероника Юрьевна'	, stend: '	110', st_name: '	Функциональные магнитоактивные металлополимерные кобальт-, никель- и железосодержащие наноматериалы, синтезированные из ненасыщенных дикарбоксилатов'	},
        {id: 	18	, descr: '	Муфтахова Лия Рустемовна'	, stend: '	131'	, st_name: '	Двумерная сверхструктура плёнки арахиновой кислоты с комплексами церия на поверхности раствора нитрата церия'	},
        {id: 	19	, descr: '	Недоедкова Ольга Вадимовна'	, stend: '	98'	, st_name: '	Изменение проводящей структуры полианилина при допировании переходными металлами'	},
        {id: 	20	, descr: '	Новичков Даниил Андреевич', stend: '	115'	, st_name: '	Спектроскопия рентгеновского поглощения в лаборатории и на синхротроне: преимущества и недостатки'	},
        {id: 	21	, descr: '	Нуретдинов Тагир Мансурович'	, stend: '	108	', st_name: '	Топологические электронные переходы в киральных ферромагнетиках FеMnSi c кубической структурой без центра инверсии'	},
        {id: 	22	, descr: '	Огаркова Надежда Константиновна'	, stend: '	97'	, st_name: '	Синтез биметаллического комплекса [PtPy2(FcCOO)2] и исследование методом EXAFS продуктов его термораспада — предшественников каталитически активных функциональных наноматериалов'	},
        {id: 	23	, descr: '	Павлов Константин Андреевич' , stend: '	129	', st_name: '	Численное моделирование установки малоуглового рассеяния нейтронов для компактного нейтронного источника'	},
        {id: 	24	, descr: '	Пелагина Александра Константиновна'	, stend: '	87'	, st_name: '	Синхротронные исследования структур нитевидного кремния	'},
        {id: 	25	, descr: '	Полякова Татьяна Романовна'	, stend: '	88'	, st_name: '	Определение валентного состояния урана с использованием XANES спектроскопии для прогноза миграции техногенного урана в условиях окружающей среды'	},
        {id: 	26	, descr: '	Постников Михаил Сергеевич'	, stend: '	109'	, st_name: '	Термическая устойчивость CuZrSe2 и CuCrSe2'	},
        {id: 	27	, descr: '	Рубцова Елизавета Дмитриевна'	, stend: '	89'	, st_name: '	Композитные материалы на основе алмаза для детектирования ионизирующего излучения'	},
        {id: 	28	, descr: '	Садыков Равиль Асхатович'	, stend: '	80'	, st_name: '	Нейтронография магнитной спирали монокристалла гексаферрита BaCo2Ti2Fe8O19 типа М в сильном магнитном поле'	},
        {id: 	29	, descr: '	Серов Егор Олегович	', stend: '	81'	, st_name: '	Разработка экспериментального стенда для получения поляризованных  нейтронов на реакторе ИР-8'},
        {id: 	30	, descr: '	Снегирёв Никита Игоревич'	, stend: '	113'	, st_name: '	Рентгеновская диагностика монокристаллических материалов в условиях воздействия внешнего магнитного поля'	},
        {id: 	31	, descr: '	Старостин Леонид Юрьевич'	, stend: '	94'	, st_name: '	Изучение строения комплексов f-элементов с полидентантными N, O –донорными гетероциклическими лигандами, методами EXAFS и ЯМР.	'},
        {id: 	32	, descr: '	Стегайлов Владимир Ильич'	, stend: '	101'	, st_name: '	Исследование продуктов реакций в мишенях висмута,урана и актинидов на ускорителях протонов и электронов с энергиями (Ep=660 Мэв) и (Ee=180 Мэв).	'},
        {id: 	33	, descr: '	Сулимова Олеся Витальевна'	, stend: '	96'	, st_name: '	Синтез гетерометаллического комплекса платины, исследование его термических превращений и каталитические свойства полученного нанесенного катализатора Pt/Zn/Al2O3	'},
        {id: 	34	, descr: '	Таланов Михаил Валерьевич' , stend: '	107'	, st_name: '	Возможности современных теоретико-групповыхметодов в решении кристаллографических задач теории фазовых переходов	'},
        {id: 	35	, descr: '	Ташметов Маннаб Юсупович'	, stend: '	83'	, st_name: '	Исследование объектов культурного наследия на установке нейтронной радиографии и томографии ИЯФ АН РУз	'},
        {id: 	36	, descr: '	Тетерин Юрий Александрович'	, stend: '	99'	, st_name: '	Применение синхротронных методов для изучения структуры смешанных карбонатов Np(V) '	},
        {id: 	37	, descr: '	Титова София Сергеевна'	, stend: '	90'	, st_name: '	Синхротронные исследования для оптимизации процесса формирования нано-био-гибридных структур и комплексов на основе наночастиц пористого кремния.'	},
        {id: 	38	, descr: '	Толчина Дарья Борисовна'	, stend: '	106'	, st_name: '	Атомное и электронное строение допированных азотом кластеров нано-графена по данным комбинированного анализа методами XPS и XANES '	},
        {id: 	39	, descr: '	Фатеев Кирилл Александрович'	, stend: '	91'	, st_name: '	Особенности атомного и электронного строения нитевидных кристаллов SnO2 по данным синхротронных исследований'	},
        {id: 	40	, descr: '	Шкварин Алексей Сергеевич	', stend: '	111'	, st_name: '	Влияние окта и тетра заполнения на электронную структуру в CuxZrSe2 и CrxZrSe2'	},
        {id: 	41	, descr: '	Шуленина Александра Владимировна'	, stend: '	82'	, st_name: '	Анализ агрегационного состояния магнитных жидкостей на основе анизотропного малоуглового рассеяния рентгеновских лучей.'	},
        {id: 	42	, descr: '	Яловега Галина Эдуардовна'	, stend: '	95'	, st_name: '	Влияние межфазных взаимодействий в системе NiOx-графеновая плоскость на формирование проводящей структуры в гибридных нанокомпозитных материалах для суперконденсаторов'},
        {id: 	43	, descr: '	Янжимаев Борис Юрьевич'	, stend: '	124'	, st_name: '	Синтез и свойства Mo- и W-содержащих катализаторов на основе цеолита со структурой MFI	'},
      ]
    }
  },


};
</script>
<style lang="scss" scoped>
  hr{
    margin: 10px;
  }

  .prog-text{
    font-style: italic;
    color:rgb(4, 43, 75);
  }
  .content-personal{
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
}
.theme--light.v-application {
    background: rgb(248, 248, 248) !important;
    color: rgba(0, 0, 0, 0.87);
}

@media screen and (max-width:767px) {
  .content-personal {
    max-width: 90% !important;
  }
  .content-personal__header {
    flex-direction: column;
  }
}
</style>
